<p-dialog [(visible)]="visible" [modal]="true" [closable]="false" [dismissableMask]="true" (onHide)="onClose()"
    [style]="{ width: '90vw', maxWidth: '500px' } ">

    <div class=" bg-gray-20 border-gray-300 space-x-4">

        <div class="bg-custom-blue w-[calc(100%+3rem)] -ml-6 px-6  pt-1  text-white rounded-t pb-4  sm:px-10">

            <h2 class=" text-2xl font-bold mt-4 font-mulish text-white">Bid Status</h2>

            <p class="text-sm mt-2  font-mulish font-semibold  text-white">Understanding how bids work is key to making
                informed decisions during an auction. Below is a breakdown of each possible bid status—what it means,
                how it
                affects your standing, and what to expect as the auction progresses.</p>
        </div>
        <div class="flex flex-col md:flex-row w-full gap-4 mt-6 text-sm ">
            <div class="rounded-lg bg-white shadow-md text-center mt-4 pb-4">
                <div class="space-y-2 px-2 mt-2">

                    <h2 class=" text-lg font-bold  font-mulish text-left">Below Reserve</h2>
                    <p class="font-mulish text-left text-gray-600">
                        The Reserve Price is the minimum required for an item to sell. If bids do not meet or exceed the
                        Reserve Price by auction end, the item will not be sold. This item's Reserve Price has not been
                        reached yet.
                    </p>
                </div>
            </div>
        </div>
        <div class="px-4">
            <button pButton
                class=" h-[40px] p-button-info rounded-m w-full relative flex items-center justify-center mt-6 "
                [rounded]="true" (click)="onClose()">
                <fa-icon [icon]="faCheckCircle" class="text-white text-base font-bold p-0 m-0 left-3"></fa-icon>
                <span class="font-semibold text-white text-center w-full text-base">
                    Done
                </span>
            </button>
        </div>
    </div>
</p-dialog>